import Login from 'views/Login/Login'

export default Login
